interface HeroPortraitFrameProps {
  src: string
  alt: string
  className?: string
  /** Bordered card style used on dashboard; plain on tips/perspectives. */
  variant?: "plain" | "card"
}

export function HeroPortraitFrame({
  src,
  alt,
  className = "",
  variant = "plain",
}: HeroPortraitFrameProps) {
  const frameClass =
    variant === "card"
      ? "overflow-hidden rounded-xl border border-[var(--color-divider)]"
      : "overflow-hidden rounded-xl border border-[var(--color-divider)]"

  return (
    <div className={`${frameClass} ${className}`.trim()}>
      <div className="aspect-[16/10] w-full">
        <img src={src} alt={alt} className="h-full w-full object-cover object-center" />
      </div>
    </div>
  )
}
